import React, { Fragment, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { OidcProvider } from 'redux-oidc';

import Routing from './containers/Routing';
import store from './utils/store';
import userManager from './utils/userManager';

// import reportWebVitals from './reportWebVitals';
// import * as serviceWorker from './serviceWorker';

import './utils/i18n';
import './styles/index.scss';
import 'react-phone-input-2/lib/plain.css';

let googleTagManagerID;
switch(process.env.REACT_APP_ENV) {
  default:
  case 'development':
    googleTagManagerID = 'GTM-528MNP6';
    break;
  case 'test':
    googleTagManagerID = 'GTM-528MNP6';
    break;
  case 'staging':
    googleTagManagerID = 'GTM-528MNP6';
    break;
  case 'production':
    googleTagManagerID = 'GTM-M3WXZHL';
    break;
}

const render = () => {

  window.GTMLoader = false;
  const initGTM = (w, d, s, l, i) => {
    if(!window.GTMLoader) {
      window.GTMLoader = true;
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event:'gtm.js' });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s);
      const dl = l !== 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    }
  };
	initGTM(window, document, 'script', 'dataLayer', googleTagManagerID);

	ReactDOM.render(
    <Suspense fallback={null}>
      <Fragment>
        <Provider store={store}>
          <OidcProvider store={store} userManager={userManager}>
            <Routing  />
          </OidcProvider>
        </Provider>
      </Fragment>
    </Suspense>,
		document.getElementById('root')
	);
};

render();

// serviceWorker.register({
//   onUpdate: () => {
//     if(caches) {
//       // Service worker cache should be cleared with caches.delete()
//       caches.keys().then((names) => {
//         for (const name of names) {
//           caches.delete(name);
//         }
//       });
//     }
//     window.location.reload();
//   }
// });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
